import { render, staticRenderFns } from "./EventSignUp.vue?vue&type=template&id=2b8639e2&scoped=true&"
import script from "./EventSignUp.vue?vue&type=script&lang=ts&"
export * from "./EventSignUp.vue?vue&type=script&lang=ts&"
import style0 from "./EventSignUp.vue?vue&type=style&index=0&id=2b8639e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8639e2",
  null
  
)

export default component.exports